var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.params)?_c('y-form-uploader',_vm._b({attrs:{"no-label":!_vm.params.label},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'y-form-uploader',_vm.params,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }